import {
    FETCH_SELECTED_MONTH_RANGE,
    FETCH_COST_PIVOT_REQUEST,
    FETCH_COST_PIVOT_SUCCESS,
    FETCH_COST_PIVOT_FAILED,
    CREATE_COST_PIVOT_FILTER_REQUEST,
    CREATE_COST_PIVOT_FILTER_SUCCESS,
    CREATE_COST_PIVOT_FILTER_FAILED,
    FETCH_COST_PIVOT_FILTER_REQUEST,
    FETCH_COST_PIVOT_FILTER_SUCCESS,
    FETCH_COST_PIVOT_FILTER_FAILED,
    FETCH_COST_PIVOT_FILTER_CONTENT,
    DELETE_COST_PIVOT_FILTER_REQUEST,
    DELETE_COST_PIVOT_FILTER_SUCCESS,
    DELETE_COST_PIVOT_FILTER_FAILED,
    FETCH_COST_PIVOT_FILTER_NAMES_REQUEST,
    FETCH_COST_PIVOT_FILTER_NAMES_SUCCESS,
    FETCH_COST_PIVOT_FILTER_NAMES_FAILED,
    FETCH_USER_TAGS_REQUEST,
    FETCH_USER_TAGS_SUCCESS,
    FETCH_USER_TAGS_FAILED,
    FETCH_COST_PIVOT_DOWNLOAD_REQUEST,
    FETCH_COST_PIVOT_DOWNLOAD_SUCCESS,
    FETCH_COST_PIVOT_DOWNLOAD_FAILED,
    FETCH_COST_PIVOT_DOWNLOAD_STATUS_REQUEST,
    FETCH_COST_PIVOT_DOWNLOAD_STATUS_SUCCESS,
    FETCH_COST_PIVOT_DOWNLOAD_STATUS_FAILED,
    RESET_DOWNLOAD_LINK,
    RESET_DOWNLOAD_STATUS,
    SET_DOWNLOAD_MODE,
    FETCH_COST_DOWNLOAD_REQUEST,
    FETCH_COST_DOWNLOAD_SUCCESS,
    FETCH_COST_DOWNLOAD_FAILED,
    FETCH_COST_DOWNLOAD_STATUS_REQUEST,
    FETCH_COST_DOWNLOAD_STATUS_SUCCESS,
    FETCH_COST_DOWNLOAD_STATUS_FAILED,
    RESET_COST_DOWNLOAD_LINK,
    RESET_COST_DOWNLOAD_STATUS,
    UPDATE_COST_PIVOT_SUMMARY
} from './mutation-type'

const mutations = {
    [FETCH_SELECTED_MONTH_RANGE]: (state, data) => {
        state.selectedMonthRange = data
    },
    [FETCH_COST_PIVOT_REQUEST]: (state, { initialize }) => {
        state.status.data = 'loading'
        if (initialize) {
            state.summary.minDate = null
            state.summary.maxDate = null
        }
    },
    [FETCH_COST_PIVOT_SUCCESS]: (state, { status, data, headers }) => {
        state.status.data = status
        if (status === 205) {
            state.dataToken = headers['x-data-token'] || null
        } else if (status !== 204) {
            if (data.summary) {
                if (data.summary.minDate && data.summary.maxDate) {
                    state.summary = data.summary
                } else {
                    state.summary.indexes = data.summary.indexes
                }
            } else {
                state.summary = {}
            }
            state.data = data.data.map((item, index) => {
                const newItem = {
                    value: item.value,
                    ...item.groupBy
                }
                if (newItem?.unblendedRate?.toString().indexOf('e-') > -1) {
                    const points = newItem.unblendedRate.toString().split('e-')
                    let decimal = 0
                    if (points[1]) {
                        decimal += Number(points[1])
                    }
                    if (points[0].split('.').length === 2) {
                        decimal += points[0].split('.')[1].length
                    }
                    newItem.unblendedRate = newItem.unblendedRate.toFixed(decimal)
                }
                return newItem
            }) || []
        } else {
            state.summary = {}
            state.data = []
        }
    },
    [FETCH_COST_PIVOT_FAILED]: (state, error) => {
        state.status.data = error?.response?.status || 'error'
    },
    [CREATE_COST_PIVOT_FILTER_REQUEST]: state => {
        state.status.filter.create = 'loading'
    },
    [CREATE_COST_PIVOT_FILTER_SUCCESS]: (state, { status }) => {
        state.status.filter.create = status
    },
    [CREATE_COST_PIVOT_FILTER_FAILED]: (state, error) => {
        state.status.filter.create = 'error'
    },
    [FETCH_COST_PIVOT_FILTER_REQUEST]: state => {
        state.status.filter.data = 'loading'
    },
    [FETCH_COST_PIVOT_FILTER_SUCCESS]: (state, { status, data }) => {
        if (data.content && data.content !== '') {
            state.savedFilter = JSON.parse(data.content)
        } else {
            state.savedFilter = {
                cols: [],
                rows: [],
                pivotFilter: {}
            }
        }
        state.status.filter.data = status
    },
    [FETCH_COST_PIVOT_FILTER_FAILED]: (state, error) => {
        state.status.filter.data = 'error'
    },
    [FETCH_COST_PIVOT_FILTER_CONTENT]: (state, data) => {
        state.filter = data
    },
    [DELETE_COST_PIVOT_FILTER_REQUEST]: state => {
        state.status.filter.delete = 'loading'
    },
    [DELETE_COST_PIVOT_FILTER_SUCCESS]: (state, { status, data }) => {
        state.status.filter.delete = status
    },
    [DELETE_COST_PIVOT_FILTER_FAILED]: (state, error) => {
        state.status.filter.delete = 'error'
    },
    [FETCH_COST_PIVOT_FILTER_NAMES_REQUEST]: state => {
        state.status.filter.names = 'loading'
    },
    [FETCH_COST_PIVOT_FILTER_NAMES_SUCCESS]: (state, { status, data }) => {
        state.status.filter.names = status
        state.filterNames = data || []
    },
    [FETCH_COST_PIVOT_FILTER_NAMES_FAILED]: (state, error) => {
        state.status.filter.names = 'error'
    },
    [FETCH_USER_TAGS_REQUEST]: state => {
        state.status.userTags = 'loading'
    },
    [FETCH_USER_TAGS_SUCCESS]: (state, { status, data }) => {
        state.status.userTags = status
        if (status === 204) {
            state.userTags = []
        } else {
            state.userTags = data.sort((a, b) => a > b ? 1 : -1)
        }
    },
    [FETCH_USER_TAGS_FAILED]: (state, error) => {
        state.status.userTags = 'error'
    },
    [FETCH_COST_PIVOT_DOWNLOAD_REQUEST]: state => {
        state.status.download = 'loading'
    },
    [FETCH_COST_PIVOT_DOWNLOAD_SUCCESS]: (state, { data }) => {
        state.status.download = 'success'
        state.downloadLink = data.s3Link
        state.downloadStatus = data.status
    },
    [FETCH_COST_PIVOT_DOWNLOAD_FAILED]: (state, error) => {
        state.status.download = 'error'
    },
    [FETCH_COST_PIVOT_DOWNLOAD_STATUS_REQUEST]: state => {
        state.status.downloadStatus = 'loading'
    },
    [FETCH_COST_PIVOT_DOWNLOAD_STATUS_SUCCESS]: (state, { data }) => {
        state.status.downloadStatus = 'success'
        state.downloadLink = data.s3Link
        state.downloadStatus = data.status
    },
    [FETCH_COST_PIVOT_DOWNLOAD_STATUS_FAILED]: (state, error) => {
        state.statu.downloadStatuss = 'error'
    },
    [RESET_DOWNLOAD_LINK]: (state) => {
        state.downloadLink = ''
    },
    [RESET_DOWNLOAD_STATUS]: (state) => {
        state.downloadStatus = ''
    },
    [SET_DOWNLOAD_MODE]: (state, value) => {
        state.downloadMode = value
    },
    [FETCH_COST_DOWNLOAD_REQUEST]: state => {
        state.status.download = 'loading'
    },
    [FETCH_COST_DOWNLOAD_SUCCESS]: (state, { data }) => {
        state.status.download = 'success'
        state.costDownloadLink = data.s3Link
        state.costDownloadStatus = data.status
        state.costDownloadDataToken = data.dataToken
    },
    [FETCH_COST_DOWNLOAD_FAILED]: (state, error) => {
        state.status.download = 'error'
    },
    [FETCH_COST_DOWNLOAD_STATUS_REQUEST]: state => {
        state.status.downloadStatus = 'loading'
    },
    [FETCH_COST_DOWNLOAD_STATUS_SUCCESS]: (state, { data }) => {
        state.status.downloadStatus = 'success'
        state.costDownloadLink = data.s3Link
        state.costDownloadStatus = data.status
    },
    [FETCH_COST_DOWNLOAD_STATUS_FAILED]: (state, error) => {
        state.status.downloadStatus = 'error'
    },
    [RESET_COST_DOWNLOAD_LINK]: (state) => {
        state.costDownloadLink = ''
    },
    [RESET_COST_DOWNLOAD_STATUS]: (state) => {
        state.costDownloadStatus = ''
        state.costDownloadDataToken = null
    },
    [UPDATE_COST_PIVOT_SUMMARY]: (state, data) => {
        if (data) {
            // Vue 2 반응성을 위해 완전히 새로운 객체로 교체
            // 일반 피벗과 다운로드 모드 모두 동일한 구조 사용
            // undefined 만 fallthrough — null/[] 등 명시적 값은 그대로 반영해야 stale 정리 가능
            state.summary = {
                minDate: data.minDate !== undefined ? data.minDate : state.summary.minDate,
                maxDate: data.maxDate !== undefined ? data.maxDate : state.summary.maxDate,
                indexes: data.indexes !== undefined ? data.indexes : state.summary.indexes,
                sizeOfData: data.sizeOfData !== undefined ? data.sizeOfData : state.summary.sizeOfData
            }
        }
    }
}

export default mutations
